export enum AdminMenu {
  KeyDates = 'key-dates',
  Reports = 'reports',
  SubmissionPeriods = 'submission-periods',
  Users = 'users',
}
